export const list_of_Options=[
    {
        id:3,
        key:"",
        name:"google pay",
        prefix:"tez://upi/",
        source:`../../${process.env.PUBLIC_URL}/images/gpay-logo.svg`,
    },
    {
        id:4,
        key:"",
        name:"paytm",
        prefix:"paytmmp://",
        source:`../../${process.env.PUBLIC_URL}/images/paytm-logo.svg`,
    },
    {
        id:5,
        key:"",
        name:"phone pe",
        prefix:"phonepe://",
        source:`../../${process.env.PUBLIC_URL}/images/phone-pay-logo.svg`,
    },
]

export const STATUS_ENQUIRY_RESPONSE_CODE = {
    TRANSACTION_SUCCESS: 1000,
    INTERNAL_ERROR: 1001,
    TRANSACTION_FAILED: 1002,
    TRANSACTION_PENDING: 1003,
    SESSION_EXPIRED: 1004,
    REQUEST_EXPIRED: 1005,
  };

export const labels = {
    SCAN_QR_CODE: "Scan The QR Code With Any UPI App",
    PAY_BY_ANY_UPI_APP: "Scan and pay by any UPI app on your phone",
    SUPPORTED_UPI_APP: "100+ Upi Apps supported",
    PAY_WITH_UPI_APP: "Pay by any UPI app",
    UPI_APP: "UPI Apps",
    FAILED_OPENING_UPI_APP: "Retry With Another UPI App!",
    PAY_WITH_ANOTHER_UPI_APP: "Make sure that the UPI app is installed on this phone",
    UPI_APP_LIST: "Upi Apps List",
    VIEW_OTHER_APPS: "View other UPI apps",
    CANCEL_PAYMENT: "Cancel Payment",
    CANCEL_PAYMENT_TEXT: "Are you sure you want to cancel the payment?",
    YES_CANCEL: "Yes, Cancel",
    NO: "No",
    TRY_WITH_ANOTHER_UPI_APP: "Try another UPI App?",
    OPENING_APP: "Opening UPI App",
    FAILED_TO_OPEN_APP: "Failed To Open UPI App",
    RETRY_PAYMENT_MODE: "Please retry with another pay mode",
    PROCESS_PAYMENT_ERROR: "Unable to process the payment at this time. Please try another payment method or try again later."
}

export const UPI_FLOWS = {
    INTENT: "INTENT",
    COLLECT: "COLLECT"
}